import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Box, Button, Container, Typography } from "@mui/material";
import { getDiscoverMore } from "../../utils/Utilities";
import Card from "../cards";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import "./discoverMore.scss";
import { style } from "@mui/system";
import VideoSection from "../videoSection";

const DiscoverMoreSection = (props) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const user = useSelector((state) => state.user);
  const [discoverData, setDicoverData] = useState([]);
  const handleIsHighlight = (targetIndex) => {
    setDicoverData(
      discoverData.map((item, index) => {
        if (targetIndex === index)
          return {
            ...item,
            isHighlighted: true,
            rederFirstElement: false,
          };
        return {
          ...item,
          isHighlighted: false,
          rederFirstElement: false,
        };
      })
    );
  };

  const scrollToBottom = () => {
    const videoSection = document.querySelector('.video-section');
    if (videoSection) {
      videoSection.scrollIntoView({ behavior: 'smooth' });
    }
    // window.scrollTo({
    //   left: 0,
    //   top: document.body.scrollHeight,
    //   behavior: "smooth",
    // });
  };

  function onClickNextArrow(e) {
    e.preventDefault();
    e.stopPropagation();
    setDicoverData((pre) =>
      pre.map((item) => {
        if (item.isHighlighted)
          return { ...item, rederFirstElement: !item.rederFirstElement };
        return item;
      })
    );
  }

  useEffect(() => {
    var observer = new MutationObserver(function (mutations) {
      if (document.contains(document.getElementById("card-right-arrow"))) {
        const element = document.getElementById("card-right-arrow");
        element.addEventListener("click", onClickNextArrow);
      }
    });
    var observer1 = new MutationObserver(function (mutations) {
      if (document.contains(document.getElementById("card-right-arrow-1"))) {
        const element = document.getElementById("card-right-arrow-1");
        element.addEventListener("click", onClickNextArrow);
      }
    });
    observer.observe(document, {
      attributes: false,
      childList: true,
      characterData: false,
      subtree: true,
    });
    observer1.observe(document, {
      attributes: false,
      childList: true,
      characterData: false,
      subtree: true,
    });
    return () => {
      observer.disconnect();
      observer1.disconnect();
    };
  }, []);

  useEffect(() => {
    setDicoverData(getDiscoverMore(t) || []);
  }, [t]);

  return (
    <Box
      component="div"
      // position="absolute"
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      bottom={0}
      left="50%"
      marginTop="50px"
    >
      <div
        style={{
        //  cursor: "pointer",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          position: "relative",
          width: "100%",
        }}
        onClick={scrollToBottom}
      >
        {user.branchLogo && (
          <Box
            className="company-logo"
            component="div"
            display="flex"
            justifyContent="end"
          >
            <img src={URL.createObjectURL(user?.branchLogo)} />
          </Box>
        )}

        <Typography
          // style={{ display: props.discoverMoreShow ? "block" : "none" }}
          sx={{ display: "block" }}
          fontWeight="bold"
          fontFamily="WixMadefor"
        >
          {t("discover-more")}
        </Typography>
        <div
          // style={{ display: props.discoverMoreShow ? "block" : "none" }}
          style={{ display: "block" }}
        >
          <img src="/assets/icons/down-arrow.png" alt="arrow" />
        </div>
      </div>
      <Box className="video-section">
        <Container className="video-section-container">
          <VideoSection />
        </Container>
      </Box>
      <Container
          sx={{
            [`@media (min-width: 1500px)`]: {
              maxWidth: "1400px",
            },
            [`@media (min-width: 3800px)`]: {
              maxWidth: "3000px",
            },
          }}
        >
        <div
          className="discover-more"
          // style={{ display: props.discoverMoreShow ? "block" : "none" }}
          style={{
            display: "block",
            padding: "50px 0em 0 0em",
            // paddingTop: "50px",
          }}
        >
          <Box
            className="card-list"
            // flexWrap="wrap"
            sx={{
              justifyContent: { lg: "space-between", xs: "center" },
              flexDirection: { lg: "row", xs: "column" },
            }}
          >
            {discoverData.map((item, index) => {
              return (
                <Card
                  title={item.title}
                  image={item.image}
                  hightlighted={item.isHighlighted}
                  // onClick={() => {
                  //   handleIsHighlight(index);
                  // }}
                />
              );
            })}
          </Box>
          {/* {discoverData.map((item) => {
          return (
            <>
              {item.isHighlighted && (
                <>
                  <div
                    dangerouslySetInnerHTML={{
                      __html: item.rederFirstElement
                        ? item.description[1]
                        : item.description[0],
                    }}
                    className="card-description"
                  />
                </>
              )}
            </>
          );
        })} */}
        </div>
      </Container>
      <div className="description">
        <p>{t("description-1.0")}</p>
        <p>{t("description-1.1")}</p>
        <br />
        <p>{t("description-2")}</p>
      </div>
      <Button
        style={{ display: props.discoverMoreShow ? "block" : "none" }}
        variant="contained"
        type="submit"
        sx={{
          padding: "10px 55px",
          color: "color.black",

          margin: "20px 0",
          bgcolor: "color.magentaLight2",
          borderRadius: 1,

          fontWeight: "bold",

          "&:hover": {
            bgcolor: "color.magentaLight2",
          },
          textTransform: "initial",
        }}
        onClick={() => {
          navigateToFirstPage(navigate);
        }}
      >
        {t("lets-get-started")}
      </Button>
    </Box>
  );
};

export default DiscoverMoreSection;
